<template>
  <b-container>
    <h1 v-translate>Bulk Provider Quotes</h1>
    <bulk-quote-providers-list />
  </b-container>
</template>
<script>
import BulkQuoteProvidersList from '@/components/BulkQuoteProvidersList'

export default {
  name: 'BulkQuoteProvidersPage',
  components: {
    BulkQuoteProvidersList
  }
}
</script>
